export const lang_options = {
  en: {
    no_of_trucks: "No of trucks in your fleet",
    no_of_trailers: "No of trailers in your fleet",
    avg_mileage_per_year: "Avg. yearly mileage of your trucks",
    avg_fuel_per_100_km: "Avg. fuel consumption/100 km",
    price_per_liter_diesel: "Price / Litre Diesel",
    savings_potentials: "Your min. savings potentials for your fleet",
    fuel_costs: "Fuel costs",
    co2_emissions: "Co2 Emissions",
    learn_more: "Learn More ?",
    company_name: "Company Name",
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone_no: "Phone No",
    submit: "Submit",
  },
  de: {
    no_of_trucks: "Anzahl der Lastwagen in Ihrer Flotte",
    no_of_trailers: "Anzahl der Anhänger in Ihrem Fuhrpark",
    avg_mileage_per_year: "Durchschnittliche jährliche Fahrleistung Ihrer Lkw",
    avg_fuel_per_100_km: "Durchschnittlicher Kraftstoffverbrauch/100 km",
    price_per_liter_diesel: "Preis/Liter Diesel",
    savings_potentials: "Ihr minimales Einsparpotenzial für Ihre Flotte",
    fuel_costs: "Kraftstoffkosten",
    co2_emissions: "Co2-Emissionen",
    learn_more: "Mehr erfahren?",
    company_name: "Firmenname",
    first_name: "Vorname",
    last_name: "Nachname",
    email: "E-Mail",
    phone_no: "Telefon-Nr.",
    submit: "Einreichen",
  },
};
